export const messagesCoupons = {
    pt: {
        message:{
            campaign: "Campanha",
            code: "Código",
            coupon: "Cupom",
            couponCode: "Código do Cupom",
            customerName: "Cliente",
            dateOfUse: "Data de uso",
            generationDate: "Data de geração",
            registerCoupon: "Cadastrar cupom",
            unused: "Não utilizados",
            spot: "Local",
            used: "Utilizados"
        }
    },
    es: {
        message:{
            campaign:"Campaña",
            code:"Código",
            coupon:"Cupón",
            couponCode:"Código de cupón",
            customerName:"Cliente",
            dateOfUse:"Fecha de uso",
            generationDate:"Fecha de generación",
            registerCoupon:"Registre el cupón",
            unused:"No usado",
            spot:"Lugar",
            used:"Utilizados"
        }
    },
    en: {
        message:{
            campaign: "Campaign",
            code: "Code",
            coupon: "Coupon",
            couponCode: "Coupon Code",
            customerName: "Customer",
            dateOfUse: "Date of use",
            generationDate: "Generation date",
            registerCoupon: "Register coupon",
            unused: "Unused",
            spot: "Spot",
            used: "Used"


        }
    }
}
